import { useQueryClient } from 'shared-ui';
import { toast } from 'react-toastify';

import { unarchiveMultiGroups } from 'api/groups/groups';
import { QueryKeyEnum } from 'core/global.enum';
import { useLocale } from 'hooks/useLocale/useLocale';
import { AppMessages } from 'i18n/messages';
import { useMutation } from 'hooks/useMutation/useMutation';
import { useSelectedGroup } from 'hooks/useSelectedGroup/useSelectedGroup';
import { useModalState } from 'hooks/useModalState/useModalState';

import { UnarchiveMultiGroups } from './UnarchiveMultiGroups';
import { UnarchiveMultiGroupsContainerProps } from './UnarchiveMultiGroups.types';

export const UnarchiveMultiGroupsContainer = ({
  checkedGroups,
  setCheckedGroups,
}: UnarchiveMultiGroupsContainerProps) => {
  const queryClient = useQueryClient();
  const { formatMessage } = useLocale();
  const { selectedGroup, setSelectedGroup } = useSelectedGroup();

  const { isModalOpen, onModalOpen, onModalClose } = useModalState();

  const { mutate: onUnarchiveMultiGroups, isLoading } = useMutation(unarchiveMultiGroups, {
    onSuccess: () => {
      if (selectedGroup && checkedGroups.some(({ id }) => id === selectedGroup?.id)) {
        setSelectedGroup(undefined);
      }

      queryClient.invalidateQueries([QueryKeyEnum.GROUPS]);
      toast.dark(formatMessage({ id: AppMessages['groups.multiAction.unarchive.successMessage'] }));
      setCheckedGroups([]);
      onModalClose();
    },
  });

  const onSubmit = () => {
    onUnarchiveMultiGroups({ body: checkedGroups.map(({ id }) => id) });
  };

  return (
    <UnarchiveMultiGroups
      checkedGroups={checkedGroups}
      isModalOpen={isModalOpen}
      onModalClose={onModalClose}
      onModalOpen={onModalOpen}
      isLoading={isLoading}
      onSubmit={onSubmit}
    />
  );
};
